import { WorkPerformer } from "src/app/services/work-performer/work-performer";


export class WorkPerformerRefresh {
	static readonly type = '[WorkPerformerResource] Refresh';
}
export class WorkPerformerCreate {
	static readonly type = '[WorkPerformerResource] Create';
	constructor(public item: WorkPerformer) { }
}
export class WorkPerformerUpdate {
	static readonly type = '[WorkPerformerResource] Update';
	constructor(public id: number, public item: WorkPerformer) { }
}
export class WorkPerformerDelete {
	static readonly type = '[WorkPerformerResource] Delete';
	constructor(public id: number) { }
}

export class WorkPerformerRefreshByID {
	static readonly type = '[WorkPerformerResource] RefreshByID';
	constructor(public id: number) { }
}
